import { IStatisticsInstructorItemModel } from "../components/StatisticsInstructorDialog";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";

export const getStatisticsInstructorDetailedItemGroups = (
  items?: IStatisticDetailedItemViewModel[]
) => {
  if (!items) {
    return;
  }

  return Object.values(
    items.reduce<Record<number, IStatisticDetailedItemViewModel[]>>(
      (acc, item) => {
        if (!acc[item.userId]) {
          acc[item.userId] = [];
        }
        acc[item.userId].push(item);
        return acc;
      },
      {}
    )
  )
    .map((group) => {
      const paidItems = group.filter((item) => !!item.pricePaid);
      if (paidItems.length === 0) return undefined;

      const userId = group[0].userId;
      const userName = group[0].userName;
      const numberOfOccurances = paidItems.length;
      const totalRevenue = paidItems.reduce(
        (sum, item) => sum + (item.pricePaidInEur ?? item.pricePaid!),
        0
      );
      const totalCommission = paidItems.reduce(
        (sum, item) => sum + (item.commissionAmountInEur ?? 0),
        0
      );

      const visits = paidItems
        .slice()
        .sort(
          (a, b) =>
            new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
        )
        .map((item) => ({
          dateTime: item.dateTime,
          pricePaidInEur: item.pricePaidInEur ?? item.pricePaid ?? null,
          commissionCategory: item.commissionCategory ?? null,
          commissionPercent: item.commissionPercent ?? null,
          commissionAmountInEur: item.commissionAmountInEur ?? null,
        }));

      return {
        userId,
        userName,
        numberOfOccurances,
        totalRevenue,
        totalCommission,
        visits,
      };
    })
    .filter((x): x is IStatisticsInstructorItemModel => !!x)
    .sort((a, b) => b.numberOfOccurances - a.numberOfOccurances);
};
